import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { MobileLoginComponentComponent } from '../mobile-login-component/mobile-login-component.component';

/**
 * Single reusable post-booking "Unlock more member offers" login card.
 * Drop in `<app-member-login-card (loggedIn)="...">` on any interstitial / booking-detail
 * page — it self-hides for non-guests, opens the app's mobile login sheet, and emits
 * `loggedIn` on success so the host can refresh its data.
 */
@Component({
  selector: 'app-member-login-card',
  templateUrl: './member-login-card.component.html',
  styleUrls: ['./member-login-card.component.scss'],
})
export class MemberLoginCardComponent implements OnInit {
  @Output() loggedIn = new EventEmitter<void>();
  isGuestUser = true;

  constructor(
    private modalController: ModalController,
    private authService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.isGuestUser = this.authService.checkIfGuestUser();
  }

  async login(): Promise<void> {
    const modal = await this.modalController.create({
      component: MobileLoginComponentComponent,
      cssClass: 'login-modal',
      backdropDismiss: true,
      showBackdrop: true,
      initialBreakpoint: 1,
    });
    await modal.present();
    const { data } = await modal.onDidDismiss();
    if (data?.success) {
      this.isGuestUser = this.authService.checkIfGuestUser();
      this.loggedIn.emit();
    }
  }
}
